import React from 'react';
import { motion } from 'framer-motion';
import { ChoiceButton } from '../components/ChoiceButton';
import { MolecularBackdrop } from '../components/MolecularBackdrop';
import { Atom, Factory, ArrowRight, Network } from 'lucide-react';
interface Props {
  onSelect: (value: string) => void;
  selectedValue?: string;
}
const options = [{
  id: 'translation',
  label: 'Translational expertise',
  icon: Atom
}, {
  id: 'manufacturing',
  label: 'Manufacturing scalability',
  icon: Factory
}, {
  id: 'supply',
  label: 'Supply chain reliability',
  icon: ArrowRight
}, {
  id: 'integrated',
  label: 'Integrated development workflows',
  icon: Network
}];
export function SlideFuture({
  onSelect,
  selectedValue
}: Props) {
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className="flex-1 flex flex-col relative px-5 pt-20 pb-28" data-id="element-478">
      <MolecularBackdrop variant="workflow" data-id="element-479" />

      <div className="relative z-10 flex-1 flex flex-col justify-center" data-id="element-480">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-481">
          <span className="text-minerva-blue text-[10px] font-bold tracking-[0.25em] uppercase mb-4 block" data-id="element-482">
            Industry Pulse · 03
          </span>
          <h2 className="text-[26px] font-display font-bold text-slate-900 leading-tight mb-7" data-id="element-483">
            Which capability will become most critical for future radiopharma
            success?
          </h2>
        </motion.div>

        <div className="flex flex-col gap-3" data-id="element-484">
          {options.map((opt, i) => <ChoiceButton key={opt.id} label={opt.label} icon={opt.icon} selected={selectedValue === opt.id} onClick={() => onSelect(opt.id)} delay={0.2 + i * 0.1} data-id="element-485" />)}
        </div>
      </div>
    </motion.div>;
}